import { IconButton } from '@synoptic/ui-kit/button/icon-button.js';
import { EditPencilIcon } from '@synoptic/ui-kit/icons/react/edit-pencil.js';
import { InfoCircleIcon } from '@synoptic/ui-kit/icons/react/info-circle.js';
import { TrashIcon } from '@synoptic/ui-kit/icons/react/trash.js';
import { useState } from 'react';
import { ConfirmModal } from '@/components/confirm-modal/confirm-modal';
import { ManageFilterModal } from '../manage-filter/manage-filter';
import { AiFilter } from '../types';
import { useDeleteAiFilter } from '../use-delete-ai-filter';
import { useEditAiFilter } from '../use-edit-ai-filter';
import {
  filterItem,
  filterItemAside,
  filterItemCollectionsContainer,
  filterItemCollectionsLabel,
  filterItemCollectionsList,
  filterItemConfirmDeleteDescription,
  filterItemContent,
  filterItemPrompt,
  filterItemTitle,
} from './manage-filters.css';
interface FilterItemProps {
  filter: AiFilter;
}

const ConfirmDeleteDescription = ({ filter }: { filter: AiFilter }) => {
  const isFilterUsed = filter.collections.length > 0;

  return (
    <>
      <p className={filterItemConfirmDeleteDescription}>
        This AI Filter is used by your lists, deleting it will remove its
        filtering effect from all associated lists, which may change the
        displayed posts.
      </p>
      {isFilterUsed && (
        <div className={filterItemCollectionsContainer}>
          <InfoCircleIcon width={24} height={24} />
          <div>
            <p className={filterItemCollectionsLabel}>
              Filter will be removed from these lists:
            </p>
            <ul className={filterItemCollectionsList}>
              {filter.collections.map((collection) => (
                <li key={collection.id}>{collection.name}</li>
              ))}
            </ul>
            <p>This action cannot be undone</p>
          </div>
        </div>
      )}
    </>
  );
};

export const FilterItem = ({ filter }: FilterItemProps) => {
  const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] =
    useState(false);
  const { deleteFilter, loading: isDeleting } = useDeleteAiFilter(filter);
  const { editFilter } = useEditAiFilter();

  return (
    <div className={filterItem}>
      <div className={filterItemContent}>
        <h3 className={filterItemTitle}>{filter.name}</h3>
        <p className={filterItemPrompt} title={filter.prompt}>
          {filter.prompt}
        </p>
      </div>
      <div className={filterItemAside}>
        <ManageFilterModal
          filter={filter}
          onSubmit={(input) => editFilter(filter.id, input)}
        >
          <IconButton variant="ghost" size="small">
            <EditPencilIcon />
          </IconButton>
        </ManageFilterModal>
        <ConfirmModal
          isOpen={isConfirmDeleteModalOpen}
          onOpenChange={setIsConfirmDeleteModalOpen}
          onSuccess={async () => {
            await deleteFilter({ variables: { id: filter.id } });
            setIsConfirmDeleteModalOpen(false);
          }}
          loading={isDeleting}
          title={`Delete ${filter.name}?`}
          description={<ConfirmDeleteDescription filter={filter} />}
        >
          <IconButton variant="ghost" size="small">
            <TrashIcon />
          </IconButton>
        </ConfirmModal>
      </div>
    </div>
  );
};
